// Configuração do Mercado Pago
// Substitua pelas suas chaves reais do Mercado Pago

export const MERCADOPAGO_CONFIG = {
  // Chave pública do Mercado Pago
  // Para desenvolvimento: use a chave de TEST
  // Para produção: use a chave de PRODUÇÃO
  PUBLIC_KEY: import.meta.env.VITE_MP_PUBLIC_KEY || 'TEST-xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
  
  // Ambiente (sandbox para testes, production para produção)
  ENVIRONMENT: import.meta.env.VITE_MP_ENVIRONMENT || 'sandbox',
  
  // URLs da API (ca-api)
  API_BASE_URL: import.meta.env.VITE_API_URL || 'http://localhost:8000',
  API_URLS: {
    // Iniciar pagamento PIX ou Cartão
    INICIAR_PAGAMENTO: (cirurgiaId) =>
      `${import.meta.env.VITE_API_URL || 'http://localhost:8000'}/cirurgia/${cirurgiaId}/iniciar-pagamento`,
    // Verificar status do pagamento
    STATUS_PAGAMENTO: (cirurgiaId) =>
      `${import.meta.env.VITE_API_URL || 'http://localhost:8000'}/cirurgia/${cirurgiaId}/pagamento`,
  },
  
  // Configurações de pagamento
  PAYMENT_CONFIG: {
    // Valor padrão do serviço premium (definido em VITE_PREMIUM_PRICE)
    DEFAULT_PRICE: parseFloat(import.meta.env.VITE_PREMIUM_PRICE) || 69.90,
    
    // Título padrão do serviço
    DEFAULT_TITLE: 'Cirurgia Premium - Consulta Pré-cirúrgica',
    
    // Quantidade padrão
    DEFAULT_QUANTITY: 1,
    
    // Tempo de expiração do PIX (em minutos)
    PIX_EXPIRATION_MINUTES: 30,
  },
  
  // Configurações de UI
  UI_CONFIG: {
    // Cores do tema
    COLORS: {
      PRIMARY: '#16a34a', // Verde
      SECONDARY: '#dc2626', // Vermelho
      SUCCESS: '#16a34a', // Verde
      WARNING: '#ea580c', // Laranja
      INFO: '#2563eb', // Azul
    },
    
    // Textos
    TEXTS: {
      LOADING: 'Processando...',
      SUCCESS: 'Pagamento Confirmado!',
      ERROR: 'Erro no Pagamento',
      PIX_INSTRUCTIONS: 'Escaneie o QR Code ou copie o código PIX',
      COPY_SUCCESS: 'Código copiado!',
      EXPIRES_IN: 'Este PIX expira em:',
      ALREADY_PAID: 'Já paguei',
      BACK: 'Voltar',
    },
  },
}

// Função para inicializar o Mercado Pago
export const initializeMercadoPago = () => {
  try {
    if (typeof window !== 'undefined' && window.MercadoPago) {
      window.MercadoPago.setPublishableKey(MERCADOPAGO_CONFIG.PUBLIC_KEY)
    }
  } catch (error) {
    console.error('Erro ao inicializar Mercado Pago:', error)
  }
}

// Função para obter a URL da API
export const getApiUrl = (endpoint) => {
  try {
    return `${MERCADOPAGO_CONFIG.API_BASE_URL}${endpoint}`
  } catch (error) {
    console.error('Erro ao construir URL da API:', error)
    return `http://localhost:8000${endpoint}`
  }
}

// Função para verificar se está em ambiente de desenvolvimento
export const isDevelopment = () => {
  try {
    return MERCADOPAGO_CONFIG.ENVIRONMENT === 'sandbox' || import.meta.env.DEV
  } catch (error) {
    return true // Assume desenvolvimento em caso de erro
  }
}

// Função para obter a chave pública (usar a chave configurada como está)
export const getPublicKey = () => {
  try {
    const key = import.meta.env.VITE_MP_PUBLIC_KEY || MERCADOPAGO_CONFIG.PUBLIC_KEY
    return key || 'TEST-xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'
  } catch (error) {
    console.error('Erro ao obter chave pública:', error)
    return 'TEST-xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'
  }
}

// Configurações específicas para PIX
export const PIX_CONFIG = {
  // Métodos de pagamento excluídos (apenas PIX disponível)
  EXCLUDED_PAYMENT_TYPES: [
    { id: 'credit_card' },
    { id: 'debit_card' },
    { id: 'bank_transfer' },
    { id: 'atm' },
    { id: 'ticket' },
  ],
  
  // Configurações de parcelamento (não aplicável para PIX)
  INSTALLMENTS: 1,
  
  // Configurações de expiração
  EXPIRATION: {
    ENABLED: true,
    MINUTES: 30,
  },
}

export default MERCADOPAGO_CONFIG
